import Main from './Main'
import Lista from './components/EstadoVeiculoLista'
import Novo from './components/NovoEstadoVeiculo'

export default [
  {
    path: 'estado-veiculo',
    name: 'config.estado-veiculo',
    component: Main,
    redirect: { name: 'config.estado-veiculo.list' },
    children: [
      {
        path: '/',
        name: 'config.estado-veiculo.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.estado-veiculo.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.estado-veiculo.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/veiculo/estado-veiculo/routes.js